<template>
  <div>
    <v-row dense class="text-left">

      <v-col cols="12" sm="12" md="12"><v-banner color="primary" class="mb-4" dark shaped
          single-line>
          <v-icon class="mr-2">mdi-hospital</v-icon>  Información de la cita
        </v-banner>
      </v-col>
    </v-row>
    <v-row dense class="text-left ml-2">
      <v-col cols="12" md="4" sm="12"><strong class="mr-2">Id Consulta: </strong>
        <!-- <v-icon class="mr-2">mdi-information-outline</v-icon> -->
        {{ fillinfo.idMedicalPractice }}</v-col>
      <v-col cols="12" md="4" sm="12"><strong class="mr-2">Fecha y hora de cita: </strong>
        <!-- <v-icon class="mr-2">mdi-information-outline</v-icon> -->
        {{ startTime }}</v-col>
      <v-col cols="12" md="4" sm="12"><strong class="mr-2">Especialidad: </strong>
        <!-- <v-icon class="mr-2">mdi-information-outline</v-icon> -->
        {{ fillinfo.specialityName }}</v-col>
    </v-row>
    <!-- <v-row v-if="!isCancelation" class="text-center">
      <v-col cols="4">
        <v-text-field
          v-model.trim="fillinfo.idMedicalPractice"
          label="Id Consulta"
          disabled
          autocomplete="off"
          dense
          type="text"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4" class="text-left">
        <v-text-field
          v-model="startTime"
          label="Fecha cita y hora de la consulta"
          disabled
          autocomplete="off"
          dense
        >
        </v-text-field>
      </v-col>

      <v-col cols="4" class="text-left">
        <v-text-field
          v-model.trim="fillinfo.specialityName"
          label="Especialidad"
          disabled
          autocomplete="off"
          dense
          type="text"
        >
        </v-text-field>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { AppointmentInfoService } from "@/app/services";

export default {
  name: "AppointmentInformation",
  props: {
    model: Object,
    // isCancelation: Boolean,
  },
  data() {
    return {
      fillinfo: {},
      startTime: "",
    };
  },
  created() {
    this.getInfo();
  },
  // watch: {
  //   model: function() {
  //     console.log("Change in patient information");
  //     this.getInfo();
  //   },
  // },
  methods: {
    getInfo() {
      this.fillinfo = {};
      let params = { idMedicalPractice: this.model.idMedicalPractice };
      AppointmentInfoService.getConsultationformation(params)
        .then((response) => {
          this.fillinfo = response.data;
          this.startTime = this.$utilFront.formatDateTime(
            this.fillinfo.registrationDate
          );
        })
        .catch((e) => {
          this.$utilFront.errorhttp(e);
        });
    },
  },
};
</script>

<style></style>
